module.exports = __webpack_public_path__ + "media/images/home/main/sakums_real-7fa122ba6ad85929acec3710280f5aab.png";